import React from 'react';
import { connect } from 'react-redux';
import { QuestionBox } from 'moovila-common';

import { resetQuestion } from '../actions';

const GlobalQuestionBox = ({question, resetQuestion}) => {
  if (!question) {
    return null;
  }
  return (
    <QuestionBox
      backTo={false}
      title={question.title || 'Question'}
      yesCallback={() => {
        question.yesCallback && question.yesCallback();
        resetQuestion();
      }}
      noCallback={() => {
        question.noCallback && question.noCallback();
        resetQuestion();
      }}
    >
      { question.message || '' }
    </QuestionBox>
  );
};

export default connect(s => s, {
  resetQuestion,
})(GlobalQuestionBox);



// WEBPACK FOOTER //
// ./src/components/GlobalQuestionBox.js